<template>
  <div class="container">
    <productDetail></productDetail>
    <div class="seckill-fixed">
      <div class="seckill-fixed-left">
        <div class="left-item">
          <img src="@/assets/icon/icon_heart.png" />
          <span>收藏</span>
        </div>
        <div class="left-item">
          <img src="@/assets/icon/icon_cart.png" />
          <span>购物车</span>
        </div>
      </div>
      <div class="seckill-fixed-right">
        <div class="button-add">加入购物车</div>
        <div class="button-buy">原价购买</div>
      </div>
    </div>
  </div>
</template>                                                                                                           

<script>
import productDetail from "../../../components/product/productDetailItem";
export default {
  components: {
    productDetail,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.seckill-fixed {
  height: 98px;
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
}

.seckill-fixed-left {
  width: 277px;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.left-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666666;
  font-size: 24px;
  img {
    height: 36px;
    width: 38px;
  }
}

.seckill-fixed-right {
  display: flex;
  flex: 1;
  flex-direction: row;
  margin: 10px;
  div {
    flex: 1;
    height: 100%;
    border-radius: 60px;
  }
}

.button-add {
  border: 1px solid #979797;
  color: #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.button-buy {
  margin-left: 10px;
  background-color: $theme-color-main;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}
</style>
